import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUserId, getDirectChatByMembers } from '../services/store-service';

const DEFAULT_DISCUSSION_PROPS = {
    id: null,
    type: 'direct',
    name: undefined,
    team: undefined,
    created_at: null,
    project: undefined,
    is_self: false,
    is_general: false,
    members: []
}

export const fetchDiscussions = (projectId, all) => fetchResources('DISCUSSIONS_FETCH_REQUESTED', { projectId }, all);

export const createDiscussion = discussionProps => {
    const currentUserId = getCurrentUserId();
    discussionProps = Object.assign({}, DEFAULT_DISCUSSION_PROPS, discussionProps, {
        created_at: new Date().getTime(),
        members: [
            {
                id: currentUserId,
                is_owner: true,
                is_muted: false,
                joined: true
            },
            ...(discussionProps.invitees || []).map(id => ({
                id,
                is_owner: false,
                is_muted: false,
                joined: false
            }))
        ]
    });

    const discussionMembersWithoutCurrent = (discussionProps.invitees || []).filter(userId => userId !== currentUserId);

    if (discussionProps.type === 'direct') {
        const discussion = getDirectChatByMembers([discussionMembersWithoutCurrent[0], currentUserId]);

        if (discussion && discussion.type === 'direct') {
            // Chat
            return Promise.resolve({ id: discussion.id });
        }
    }

    return dispatchPromise({
        type: 'DISCUSSION_CREATE_REQUESTED',
        payload: {
            discussion: discussionProps
        }
    }).then(response => response);
}

export const fetchDiscussion = discussionId => {
    return dispatchPromise({
        type: 'DISCUSSION_FETCH_REQUESTED',
        payload: { discussionId }
    });
}

export const updateDiscussion = (discussionId, discussionProps) => {
    return dispatchPromise({
        type: 'DISCUSSION_UPDATE_REQUESTED',
        payload: {
            discussionId,
            discussionProps
        }
    });
}

export const removeDiscussion = (discussionId, force) => {
    return dispatchPromise({
        type: 'DISCUSSION_REMOVE_REQUESTED',
        payload: {
            discussionId,
            force
        }
    });
}

export const muteDiscussion = discussionId => {
    return dispatchPromise({
        type: 'DISCUSSION_MUTE_REQUESTED',
        payload: {
            discussionId,
            userId: getCurrentUserId()
        }
    });
}

export const unmuteDiscussion = discussionId => {
    return dispatchPromise({
        type: 'DISCUSSION_UNMUTE_REQUESTED',
        payload: {
            discussionId,
            userId: getCurrentUserId()
        }
    });
}

export const leaveDiscussion = discussionId => {
    return dispatchPromise({
        type: 'DISCUSSION_LEAVE_REQUESTED',
        payload: { discussionId }
    });
}

export const addDiscussionMembers = (discussionId, members) => {
    return dispatchPromise({
        type: 'DISCUSSION_ADD_MEMBERS_REQUESTED',
        payload: {
            discussionId,
            members: members.map(userId => ({
                id: userId,
                is_owner: false,
                is_muted: false,
                joined: false
            }))
        }
    });
}

export const removeDiscussionMembers = (discussionId, members) => {
    return dispatchPromise({
        type: 'DISCUSSION_REMOVE_MEMBERS_REQUESTED',
        payload: {
            discussionId,
            members
        }
    });
}

export const pinMessage = (discussionId, messageId) => {
    return dispatchPromise({
        type: 'DISCUSSION_PIN_MESSAGE_REQUESTED',
        payload: {
            discussionId,
            messageId
        }
    });
}
